import 'core-js/proposals/reflect-metadata';
//import 'core-js/client/shim';
//import 'zone.js/dist/zone';
import 'zone.js';

import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { UpgradeModule } from "@angular/upgrade/static";
import { UrlService } from '@uirouter/core';
import { getUIRouter } from '@uirouter/angular-hybrid'
import { AppModule } from './app/app.module';
import { NgZone } from '@angular/core';

//import { ng1App } from "./app/ng1.module";

//ng1App.config([ '$urlServiceProvider', ($urlService: UrlService) => $urlService.deferIntercept() ]);

platformBrowserDynamic().bootstrapModule(AppModule).then(platformRef => {
  //const upgrade = platformRef.injector.get(UpgradeModule) as UpgradeModule;
  
  // Ensure AngularJS destroys itself on hot reloads.
  // if (window['$injector']) {
  //   window['$injector'].get('$uiRouter').dispose();
  //   window['$injector'].get('$rootScope').$destroy();
  // }

  
  //angular.element(document).ready(function () {
    
    // upgrade.bootstrap(document.body,['mySynch']);
    // window['$injector'] = (angular.element(document.body) as any).injector()
  //});

   // get() UrlService from DI (this call will create all the UIRouter services)

   // *********************************
    const url: UrlService = getUIRouter(platformRef.injector).urlService;

   // Instruct UIRouter to listen to URL changes
   function startUIRouter() {
    url.listen();
    url.sync();
  }

  platformRef.injector.get<NgZone>(NgZone).run(startUIRouter);
 // *********************************

 // console.log('hybrid ap boostrapped')
});
//platformBrowserDynamic().bootstrapModule(AppModule)

